import type Store from "@ember-data/store";
import type ApplicationInstance from "@ember/application/instance";

export function initialize(owner: ApplicationInstance): void {
  const store = owner.lookup("service:store") as Store;

  const data = [
    "nephro",
    "pneumo",
    "hepato",
    "onco",
    "cardio",
    "mental",
    "diabeto",
    "digest",
    "generic"
  ];

  data.forEach(id => {
    store.createRecord("therapeutical-area", { id });
  });
}

export default {
  initialize
};
